import React from 'react';

interface StyleOptionProps {
  value: string;
  label: string;
  image: string;
  isSelected: boolean;
  onClick: (value: string) => void;
  rotateImage?: boolean;
  zoomLevel?: number;
  focusTop?: string;
}

export default function StyleOption({ value, label, image, isSelected, onClick, rotateImage = false, zoomLevel = 1, focusTop = 'full' }: StyleOptionProps) {
  return (
    <div 
      className="content-stretch flex flex-col gap-2 items-center relative w-full cursor-pointer"
      onClick={() => onClick(value)}
    >
      <div className="relative rounded-[10px] shrink-0 w-24 h-24">
        <div 
          className={`absolute inset-0 rounded-[10px] transition-all duration-200 ${
            isSelected 
              ? 'bg-[rgba(68,129,253,0.08)] border-2 border-[#4481fd]' 
              : 'bg-[rgba(68,129,253,0.08)] hover:bg-[rgba(68,129,253,0.12)]'
          }`}
        >
          <div className="absolute inset-0 overflow-hidden rounded-[10px]">
            <img 
              alt={label} 
              className={`absolute left-[-10.43%] max-w-none w-[117.96%] h-[117.96%] ${
                focusTop === 'head' ? 'top-[130%]' : focusTop === 'mid' ? 'top-[30%]' : 'top-[-7.55%]'
              } ${rotateImage ? 'transform -rotate-90' : ''} ${
                // Add specific styling for cartoon images to prevent smearing
                value === 'cartoon' ? 'object-cover object-center' : ''
              }`}
              style={{ transform: `${rotateImage ? 'rotate(-90deg) ' : ''}scale(${zoomLevel})` }}
              src={image} 
            />
          </div>
        </div>
        {isSelected && (
          <div className="absolute border-[#4481fd] border-[3px] border-solid inset-[-3px] rounded-[13px]" />
        )}
      </div>
      <p className="font-inter font-normal leading-[1.4] not-italic relative shrink-0 text-blue-black-90 text-[12px] text-center text-nowrap whitespace-pre">
        {label}
      </p>
    </div>
  );
}
